import {
  ANTICHEAT_LOADING,
  ANTICHEAT_ERROR,
  ANTICHEAT_FLAGGED_LOADED,
  ANTICHEAT_PLAYER_SUMMARY_LOADED,
  ANTICHEAT_PLAYER_OBSERVATIONS_LOADED,
  ANTICHEAT_CLEAR_PLAYER,
} from '../actions/anticheatActions';

const initialState = {
  loading: false,
  error: null,
  flaggedPlayers: [],
  selectedPlayer: null,
  selectedPlayerSummary: null,
  selectedPlayerObservations: [],
};

const anticheatReducer = (state = initialState, action) => {
  switch (action.type) {
    case ANTICHEAT_LOADING:
      return { ...state, loading: true, error: null };

    case ANTICHEAT_ERROR:
      return { ...state, loading: false, error: action.payload };

    case ANTICHEAT_FLAGGED_LOADED:
      return { ...state, loading: false, flaggedPlayers: action.payload };

    case ANTICHEAT_PLAYER_SUMMARY_LOADED:
      return {
        ...state,
        loading: false,
        selectedPlayer: action.payload.steamId,
        selectedPlayerSummary: action.payload.summary,
      };

    case ANTICHEAT_PLAYER_OBSERVATIONS_LOADED:
      return {
        ...state,
        selectedPlayerObservations: action.payload.batches,
      };

    case ANTICHEAT_CLEAR_PLAYER:
      return {
        ...state,
        selectedPlayer: null,
        selectedPlayerSummary: null,
        selectedPlayerObservations: [],
      };

    default:
      return state;
  }
};

export default anticheatReducer;
